"use strict";
export function init() {
  const modalOpen = document.getElementsByClassName("modal-open");
  const modal = document.getElementsByClassName("modal");
  const modalCover = document.getElementsByClassName("modal-cover");

  let modalCloseAction;
  let dataModalOpen;
  let selectModal;
  let targetModal;

  const TIMEOUT_SPEED = 500;

  for (var i = 0; i < modalOpen.length; i++) {
    (function (n) {
      modalCloseAction = function (e) {
        targetModal = e.currentTarget.closest(".modal");
        targetModal.classList.add("is-close");
        document.body.style.overflow = "";
        setTimeout(function (e) {
          targetModal.classList.remove("is-open");
          targetModal.classList.remove("is-close");
        }, TIMEOUT_SPEED);
      };

      const modalWrapClose = function () {
        for (var a = 0; a < modalOpen.length; a++) {
          (function (b) {
            modalCover[b].addEventListener(
              "click",
              function (e) {
                if (e.currentTarget.classList.contains("modal-cover")) {
                  modalCloseAction(e);
                }
              },
              false
            );
          })(a);
        }
      };
      const modalWrapOpen = function (e) {
        dataModalOpen = e.currentTarget.getAttribute("data-modal-open");
        for (var a = 0; a < modal.length; a++) {
          if (modal[a].getAttribute("data-modal") === dataModalOpen) {
            modal[a].classList.add("is-open");
            // lock.scrollLock()
            document.body.style.overflow = "hidden";
            modalWrapClose();
            return false;
          }
        }
      };

      modalOpen[n].addEventListener(
        "click",
        function (e) {
          modalWrapOpen(e);
        },
        false
      );
    })(i);
  }

  const modalBtnClose = document.querySelectorAll(".modal-close");
  for (var i = 0; i < modalBtnClose.length; i++) {
    (function (n) {
      modalBtnClose[n].addEventListener(
        "click",
        function (e) {
          document.body.style.overflow = "";
          modalCloseAction(e);
          return false;
        },
        false
      );
    })(i);
  }
}
